import { render } from "./WorldSwiper.vue?vue&type=template&id=3892a640&scoped=true&ts=true"
import script from "./WorldSwiper.vue?vue&type=script&lang=ts"
export * from "./WorldSwiper.vue?vue&type=script&lang=ts"

import "./WorldSwiper.vue?vue&type=style&index=0&id=3892a640&lang=scss&scoped=true"

import exportComponent from "/Users/macbook/Documents/work_code/global/events_gevents.37games.com/src/resource/guidetro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3892a640"]])

export default __exports__